module.exports = __webpack_public_path__ + "img/hly-qrcode.fced5cc1.png";